<header>
	<h1 i18n>Отмена запроса</h1>
	<app-svg assetsPath="close" (click)="close$.next()"></app-svg>
</header>
<section>
	<span i18n>Вы действительно хотите отменить запрос?</span>
</section>
<footer>
	<button class="secondary" (click)="close$.next(false)" i18n>Нет</button>
	<button class="primary" (click)="cancelRefund()" i18n>Да</button>
</footer>
